module.exports = __webpack_public_path__ + "static/media/AZ.032ce08e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/AZ.svg
// module id = 197
// module chunks = 0